import qs from "qs";
import request from "@/utils/request";
import requestSC from "@/utils/requestSC";

export async function queryGoodsList(params) {
  return requestSC.get("/mob/goods/queryGoodsList", {
    params
  });
  // return request({
  //   url: '/mob/goods/queryGoodsList',
  //   method: 'post',
  //   params,
  // });
}

// 大数据推荐商品/店铺
export async function getDsjapiList(params) {
  return request.post("nxin.dsjapi.recommend.detailinfo.list/1.0", qs.stringify(params));
}
